import client, { PaginatedResponse, Response } from './client';
import { OrderInput, Server } from '../../types/order';
import { OrderPaymentType, PaymentMethod } from '../../types/constants';
import qs from 'qs';
import { Moment } from 'moment';

export type LoadOrdersParams = {
  page: number;
  filter: {
    stores?: string[];
    created_between?: undefined | string[] | Moment[];
    customer_details?: string;
  };
};

export type CreateOrderData = OrderInput & {
  payment_type: OrderPaymentType;
  payment_method_id: PaymentMethod;
  delivery_quote_id?: number;
  room_service_location_id?: number;

  promo?: null | string;

  room_service_details?: string;
};

export const loadOrders = (params: LoadOrdersParams): PaginatedResponse<Server.OrderData> =>
  client.get(`/orders`, { params, paramsSerializer: qs.stringify });

export const loadOrder = (id: string): Response<Server.OrderData> => client.get(`/orders/${id}`);

export const draftOrder = (storeId: string, data: CreateOrderData): Response<Server.OrderData> =>
  client.post(`/stores/${storeId}/order-drafts`, data);

export const createOrder = (storeId: string, data: CreateOrderData): Response<Server.OrderData> =>
  client.post(`/stores/${storeId}/orders`, data);
